import { TicketPriority, orderedTicketPriorities, ticketPriorityLabels } from "@swivl-mono/types";
import { Select, SelectItem, SelectOutlet } from "@swivl-mono/ui";
import { IoIosArrowDown } from "react-icons/io";

import { TicketPropertyRow } from "./TicketPropertyRow";

type PriorityFieldProps = {
  value: TicketPriority;
  onChange: (priority: TicketPriority) => void;
  pending?: boolean;
};

// "No Priority" first, a divider, then the levels (Urgent → Low).
const priorityOptions: SelectItem[] = [
  { label: ticketPriorityLabels[TicketPriority.NONE], value: TicketPriority.NONE },
  { type: "divider" as const },
  ...orderedTicketPriorities.filter((p) => p !== TicketPriority.NONE).map((p) => ({ label: ticketPriorityLabels[p], value: p }))
];

export function PriorityField({ value, onChange, pending }: PriorityFieldProps) {
  return (
    <TicketPropertyRow label="Priority" pending={pending}>
      <Select
        options={priorityOptions}
        selectedValues={[value]}
        onChange={(selected) => onChange(selected[0] as TicketPriority)}
        styles={{ [SelectOutlet.POPOVER]: { minWidth: 200, width: "auto" } }}
        customTrigger={({ isOpen }) => (
          <button className={`flex cursor-pointer items-center gap-1 rounded px-2 py-0.5 text-sm ${isOpen ? "bg-grey-100" : "hover:bg-grey-50"}`}>
            <span>{ticketPriorityLabels[value]}</span>
            <IoIosArrowDown className={`h-3.5 w-3.5 text-grey-600 transition-transform ${isOpen ? "rotate-180" : ""}`} />
          </button>
        )}
      />
    </TicketPropertyRow>
  );
}
